import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../pages/home'
import PromoPremium from '../pages/PromoPremium'
import Timnas from '../pages/Timnas.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'MNC Play Addon Purchase' }
  },
  {
    path: '/promopremium', // <-- Tambahkan route baru
    name: 'PromoPremium',
    component: PromoPremium,
    meta: { title: 'Promo Premium' }
  },
  {
    path: '/paket', // <-- Tambahkan route baru
    name: 'Paket',
    component: Timnas,
    meta: { title: 'Paket' }
  }


]

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.afterEach((to) => {
  Vue.nextTick(() => {
      document.title = to.meta.title
  })
})

export default router